export default __webpack_public_path__ + "static/SRF Carasweet 5SGF7203 - Product Specifications & Technical Data-955ce9eb37d85972cfcb5c3b33259690.pdf";